import { type SxProps } from '@mui/material';

export const defaultButtonStyles: SxProps = {
  textTransform: 'none',
};
